export function openFrontChatPopup() {
  window.FrontChat('show');
}
